import { css } from 'emotion';
import React from 'react';
import { useTheme } from '../../../theme-context';
import UnitsAvailable from '../../basic/units-available';
import './units-available-line-style.scss';

interface IUnitsAvailableLineParams {
    title?: string;
    total: number;
    available: number;
}

const UnitsAvailableLine = ({
    title,
    total,
    available,
}: IUnitsAvailableLineParams) => {
    const { getFont } = useTheme();

    return (
        <div className="sticky-header">
            <div
                className={css({
                    marginLeft: '16px',
                    marginRight: '16px',
                    marginBottom: '16px',
                })}
            >
                {title ? (
                    <div
                        data-testid="title"
                        className={css({
                            fontFamily: getFont('desktop/body/medium/bold')
                                .fontFamily,
                            fontWeight: getFont('desktop/body/medium/bold')
                                .fontWeight,
                            fontSize: getFont('desktop/body/medium/bold')
                                .fontSize,
                            marginBottom: '2px',
                        })}
                    >
                        {title}
                    </div>
                ) : undefined}
                <UnitsAvailable total={total} available={available} />
            </div>
        </div>
    );
};

export default UnitsAvailableLine;
